(function(){
  'use strict';

  /* ── CURSOR ── */
  var cu=document.getElementById('CU'), cur=document.getElementById('CUR');
  if(cu && cur && window.matchMedia('(hover:hover)').matches){
    document.addEventListener('mousemove',function(e){
      cu.style.left=e.clientX+'px'; cu.style.top=e.clientY+'px';
      cur.style.left=e.clientX+'px'; cur.style.top=e.clientY+'px';
    });
    document.querySelectorAll('a,button').forEach(function(el){
      el.addEventListener('mouseenter',function(){cur.style.width='52px';cur.style.height='52px';});
      el.addEventListener('mouseleave',function(){cur.style.width='36px';cur.style.height='36px';});
    });
  }

  /* ── PRELOADER ── */
  var pl=document.getElementById('PL'), plf=document.getElementById('PLF'), pln=document.getElementById('PLN');
  var plImg=document.getElementById('PL-IMG');
  if(pl){
    if(plImg){setTimeout(function(){plImg.style.opacity='1';plImg.style.transform='scale(1) translateY(0)';},100);}
    var prog=0;
    var iv=setInterval(function(){
      prog+=Math.random()*16+4;
      if(prog>=100){prog=100;clearInterval(iv);}
      if(plf)plf.style.width=prog+'%';
      if(pln)pln.textContent=Math.floor(prog)+'%';
      if(prog===100){setTimeout(function(){pl.classList.add('hidden');},300);}
    },60);
    setTimeout(function(){clearInterval(iv);if(plf)plf.style.width='100%';if(pln)pln.textContent='100%';pl.classList.add('hidden');},3500);
  }

  /* ── NAV SCROLL ── */
  var nav=document.getElementById('NAV');
  if(nav){
    function onScroll(){nav.classList.toggle('scrolled',window.scrollY>40);}
    window.addEventListener('scroll',onScroll,{passive:true});
    onScroll();
  }

  /* ── MOBILE MENU ── */
  var nmob=document.getElementById('NMOB');
  if(nmob){
    document.addEventListener('click',function(e){
      var ham=document.getElementById('HAM');
      if(!nmob.contains(e.target)&&ham&&!ham.contains(e.target)){
        nmob.classList.remove('open');
        if(ham)ham.classList.remove('open');
      }
    });
    nmob.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click',function(){
        nmob.classList.remove('open');
        var ham=document.getElementById('HAM');
        if(ham)ham.classList.remove('open');
      });
    });
  }

  /* ── SCROLL REVEAL ── */
  if('IntersectionObserver' in window){
    var revEls=document.querySelectorAll('.step,.testimonial,.svc-card,.blog-strip-card,.bsc-body,.iwt-text,.iwt-media,[data-reveal]');
    revEls.forEach(function(el){
      el.style.opacity='0';
      el.style.transform='translateY(28px)';
      el.style.transition='opacity .7s cubic-bezier(.16,1,.3,1),transform .7s cubic-bezier(.16,1,.3,1)';
    });
    var revObs=new IntersectionObserver(function(entries){
      entries.forEach(function(entry,i){
        if(entry.isIntersecting){
          setTimeout(function(){
            entry.target.style.opacity='1';
            entry.target.style.transform='translateY(0)';
          },0);
          revObs.unobserve(entry.target);
        }
      });
    },{threshold:0.1,rootMargin:'0px 0px -40px 0px'});
    revEls.forEach(function(el){revObs.observe(el);});
  }

  /* ── PRODUCT IMAGE SWAP ── */
  var mainImg=document.getElementById('MainProductImg');
  if(mainImg){
    document.querySelectorAll('.product-thumbs img').forEach(function(thumb){
      thumb.addEventListener('click',function(){mainImg.src=this.dataset.full||this.src.replace('120x120','700x700');});
    });
  }

  /* ── CART AJAX (optional live count) ── */
  document.querySelectorAll('[data-add-to-cart]').forEach(function(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var fd=new FormData(form);
      fetch('/cart/add.js',{method:'POST',body:fd})
        .then(function(r){return r.json();})
        .then(function(){
          return fetch('/cart.js');
        })
        .then(function(r){return r.json();})
        .then(function(cart){
          var count=document.querySelector('.n-cart-count');
          if(cart.item_count>0){
            if(!count){
              count=document.createElement('span');
              count.className='n-cart-count';
              document.querySelector('.n-cart')&&document.querySelector('.n-cart').appendChild(count);
            }
            count.textContent=cart.item_count;
          }
        });
    });
  });

})();

/* ── SLIDESHOW globals (used by inline onclick) ── */
var _ssState={};
function goSlide(id,n){
  if(!_ssState[id])_ssState[id]={cur:0};
  var track=document.getElementById('SST-'+id);
  if(!track)return;
  var slides=track.querySelectorAll('.ss-slide');
  var dots=document.querySelectorAll('#SS-'+id+' .ss-dot');
  _ssState[id].cur=(n+slides.length)%slides.length;
  track.style.transform='translateX(-'+_ssState[id].cur*100+'%)';
  dots.forEach(function(d,i){d.classList.toggle('active',i===_ssState[id].cur);});
}
function changeSlide(id,d){
  if(!_ssState[id])_ssState[id]={cur:0};
  goSlide(id,_ssState[id].cur+d);
}

/* ── NAV DROPDOWN FIX ── */
(function(){
  document.querySelectorAll('.n-dd').forEach(function(dd){
    var t;
    function keep(){ clearTimeout(t); dd.classList.add('open'); }
    function later(){ t = setTimeout(function(){ dd.classList.remove('open'); }, 150); }
    dd.addEventListener('mouseenter', keep);
    dd.addEventListener('mouseleave', later);
    var btn = dd.querySelector('button');
    if(btn) btn.addEventListener('click', function(e){ e.stopPropagation(); dd.classList.toggle('open'); });
  });
  document.addEventListener('click', function(){
    document.querySelectorAll('.n-dd.open').forEach(function(d){ d.classList.remove('open'); });
  });
})();
